export default __webpack_public_path__ + "static/media/p4-7.5c2470d7.png";